import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { store } from './store';
import '@/styles/index.css';
import { colors } from '@/styles/theme.ts';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: colors.purple.DEFAULT,
              color: '#fff',
              fontFamily: 'Poppins, sans-serif',
            },
            success: {
              style: {
                background: colors.success.DEFAULT,
              },
            },
            error: {
              style: {
                background: colors.danger.DEFAULT,
              },
            },
          }}
        />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
